import { render, staticRenderFns } from "./IfcConverterBadge.svg.vue?vue&type=template&id=0e1df88c"
import script from "./IfcConverterBadge.svg.vue?vue&type=script&lang=ts"
export * from "./IfcConverterBadge.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e1df88c')) {
      api.createRecord('0e1df88c', component.options)
    } else {
      api.reload('0e1df88c', component.options)
    }
    module.hot.accept("./IfcConverterBadge.svg.vue?vue&type=template&id=0e1df88c", function () {
      api.rerender('0e1df88c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/IfcConverterBadge.svg.vue"
export default component.exports